import * as React from "react";

const SvgTooltipsArrow = props => <svg viewBox="0 0 20 11" xmlSpace="preserve" width="1em" height="1em" {...props}><path d="M8.5.8c.8-1 2.3-1 3.1 0L20 11H0L8.5.8z" /></svg>;

export default SvgTooltipsArrow;